module.exports = __webpack_public_path__ + "media/assets/images/flags/sy-6a1e42dc33afc7cf604345afe4a7c3e2.svg";